import { useTranslation } from 'module/hooks/use-translation';
import { ModalFuncProps } from 'antd/es/modal';
import { confirm } from './methods';
import * as styles from './modal.module.css';

export const useDeleteConfirmModal = (
  config: ModalFuncProps = {},
): (() => void) => {
  const okText = useTranslation('delete');
  const cancelText = useTranslation('cancel');

  return () =>
    confirm({
      okText,
      okType: 'danger',
      cancelText,
      onCancel: () => {},
      okButtonProps: {
        ...config.okButtonProps,
        className: `modal-confirm-button ${styles.ok_button} ${
          config.okButtonProps?.className ?? ''
        }`,
        style: {
          ...config.okButtonProps?.style,
        },
      },
      ...config,
    });
};
